var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29154 21.8542C5.86867 21.745 4.51671 21.189 3.42868 20.2656C2.34065 19.3422 1.5722 18.0986 1.23305 16.7124C0.893906 15.3263 1.0014 13.8684 1.54019 12.5469C2.07898 11.2255 3.02151 10.1081 4.2332 9.35425C4.49103 7.34393 5.47258 5.49644 6.99416 4.15754C8.51574 2.81864 10.4731 2.08008 12.4999 2.08008C14.5267 2.08008 16.484 2.81864 18.0056 4.15754C19.5272 5.49644 20.5087 7.34393 20.7665 9.35425C21.9782 10.1081 22.9208 11.2255 23.4595 12.5469C23.9983 13.8684 24.1058 15.3263 23.7667 16.7124C23.4275 18.0986 22.6591 19.3422 21.5711 20.2656C20.483 21.189 19.1311 21.745 17.7082 21.8542V21.874H7.29154V21.8542ZM13.5415 13.5407H16.6665L12.4999 8.33238L8.3332 13.5407H11.4582V17.7074H13.5415V13.5407Z",
    fill: "#0D6EFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c7d34cdc6b76abb94897581ab4f2c43a.svg";
export { ForwardRef as ReactComponent };